(ns hai.ui.keyboard
  "Keyboard-chord helpers shared by every surface: which modifier the host
   platform uses and the submit chord built on it.")

(def mac?
  "True when running on a Mac/iOS device — for picking ⌘ vs Ctrl in shortcuts."
  (boolean (and (exists? js/navigator)
                (re-find #"(?i)mac|iphone|ipad" (or (.-platform js/navigator) "")))))

(defn submit-shortcut?
  "True for the platform's submit chord (⌘/Ctrl + Enter)."
  [e]
  (and (= "Enter" (.-key e))
       (or (.-metaKey e) (.-ctrlKey e))))
